import { render, staticRenderFns } from "./VoyagePlanRequestCard.vue?vue&type=template&id=2acb999f&"
import script from "./VoyagePlanRequestCard.vue?vue&type=script&lang=js&"
export * from "./VoyagePlanRequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports